import {Box} from '@mui/material';
import {useTranslation} from 'react-i18next';
import ResponsiveTypography from './responsive-typography';

interface FormLabelProps {
  text: string;
  required?: boolean;
}

const FormLabel: React.FC<FormLabelProps> = ({text, required}) => {
  const {t} = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5
      }}
    >
      {t(text)}
      {!required ? (
        <ResponsiveTypography
          sx={{
            marginTop: 0.5
          }}
          smallAllSizes
        >
          {t('optional')}
        </ResponsiveTypography>
      ) : null}
    </Box>
  );
};

export default FormLabel;
